import { laptopMediumMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const FaqContentWrapper = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: -290px auto 0 auto;
  padding: 0px 10px;
`;

export const FaqSearchTitle = styled.h2`
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.white};

  @media (${laptopMediumMax}) {
    font-size: 30px;
  }

  @media (${tabletMax}) {
    font-size: 24px;
  }

  @media (${mobileXXLargeMax}) {
    font-size: 20px;
  }
`;

export const FaqMainContentContainer = styled.div`
  display: flex;

  /* if changing media query, also update RelatedArticles & RelatedArticlesContainer in FaqRelatedArticles.style */
  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const FaqMainContentWrapper = styled.div`
  flex: 1;
`;

export const FaqMainContent = styled.section<{ base?: boolean }>`
  ${({ base }) =>
    !base
      ? css`
          border-radius: 8px;
          box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
          background-color: ${({ theme }) => theme.white};

          ${FaqMainContentWrapper} {
            padding: 25px;
          }
        `
      : ''}
`;
